import React from 'react'

const NotFound404 = () => {
  return (
    <>
        {/* <p>
        NotFound404
        </p> */}

<div className="container">
            <div className="row">
                <div className="col-md-6 offset-md-3 text-center">
                    <h1 className="display-4" style={{ color: 'blue' }}>404 - Not Found</h1>
                    <p className="lead" style={{ color: 'red' }}>Sorry, the page you are looking for does not exist.</p>
                </div>
            </div>
        </div>

    </>
  )
}

export default NotFound404